import { Badge } from "@mantine/core";

function JobStatusBadge({ status, ...props }) {
  switch (status) {
    case "queued":
      return (
        <Badge color="gray" {...props}>
          queued
        </Badge>
      );
    case "processing":
      return (
        <Badge color="blue" {...props}>
          processing
        </Badge>
      );
    case "success":
      return (
        <Badge {...props}>
          success
        </Badge>
      );
    case "failed":
      return (
        <Badge color="red" {...props}>
          failed
        </Badge>
      );
    default:
      return (
        <Badge color="gray" {...props}>
          unknown
        </Badge>
      );
  }
}

export default JobStatusBadge;
